import React from 'react';
import { put, takeLatest } from 'redux-saga/effects';
import { message } from 'antd';
import {
  DETAIL_GET_COMMENT_LIST_53,
  DETAIL_GET_GRADE_53,
  DETAIL_ADD_COMMENT_53,
  DETAIL_ADD_ZAN_53,
  USER_SCORE_FORSTORE_70,
} from '../config';
import {
  DETAIL_GET_COMMENT_LIST_REQUEST,
  DETAIL_GET_GRADE_REQUEST,
  DETAIL_ADD_COMMENT_REQUEST,
  DETAIL_ADD_ZAN_REQUEST,
  DETAIL_GET_COMMENT_LIST_SUCCESS,
  DETAIL_GET_GRADE_SUCCESS,
  DETAIL_ADD_COMMENT_SUCCESS,
  DETAIL_ADD_ZAN_SUCCESS,
  USER_SCORE_FORSTORE_REQUEST,
  USER_SCORE_FORSTORE_SUCCESS,
} from '../constants/comment';
import { createAxios } from '../utils/utils';
import success from '../static/msg-success.svg';
import fail from '../static/msg-fail.svg';

/**
 * 获取应用评论list
 */
function* fetchAddComment({ bizIdentity, content, grade, time }) {
  try {
    yield put({
      type: DETAIL_ADD_COMMENT_SUCCESS,
      payload: { inLoadding: true, bizIdentity },
    });
    const axios = yield createAxios('isNeedUser');
    const res = yield axios.post(DETAIL_ADD_COMMENT_53, { bizIdentity, content, grade });

    if (res.data) {
      if (res.data.status === 0) {
        // message.info('评论成功');
        message.success({
          content: '评论成功',
          className: 'ant-message-notice-center',
          icon: <img className="ant-message-custom-img" src={success} alt="success" />,
        });
      } else if (res.data.status === 200201) {
        // message.info(res.data.message || '评论失败，请检查评论内容是否合法');
        message.error({
          content: res.data.message || '评论失败，请检查评论内容是否合法',
          icon: <img className="ant-message-custom-img" src={fail} alt="success" />,
        });
      } else {
        // message.info(res.data.message || '发表评论失败，请稍后再试');
        message.error({
          content: res.data.message || '发表评论失败，请稍后再试',
          icon: <img className="ant-message-custom-img" src={fail} alt="success" />,
        });
      }
      yield put({
        type: DETAIL_ADD_COMMENT_SUCCESS,
        payload: { ...res.data, inLoadding: false, bizIdentity, content, grade, time },
      });
    }
  } catch (error) {
    // message.info('发表评论失败，请稍后再试');
    message.error({
      content: '发表评论失败，请稍后再试',
      icon: <img className="ant-message-custom-img" src={fail} alt="success" />,
    });
    yield put({
      type: DETAIL_ADD_COMMENT_SUCCESS,
      payload: { error: true, inLoadding: false, bizIdentity },
    });
  }
}

/**
 * 获取应用评论list
 */
function* fetchGetCommentList({ bizIdentity, count, orderBy, startIndex, isNeedUser }) {
  try {
    let axios;
    if (isNeedUser) {
      axios = yield createAxios('isNeedUser');
    } else {
      axios = yield createAxios();
    }
    const res = yield axios.post(DETAIL_GET_COMMENT_LIST_53, {
      bizIdentity,
      count,
      orderBy,
      startIndex,
    });

    if (res.data.status === 0) {
      yield put({
        type: DETAIL_GET_COMMENT_LIST_SUCCESS,
        payload: { ...res.data.data, bizIdentity },
      });
    }
  } catch (error) {
    // throw error;
  }
}
/**
 * 获取应用评分信息
 */
function* fetchGetGrade({ bizIdentity }) {
  try {
    const axios = yield createAxios();
    const res = yield axios.post(DETAIL_GET_GRADE_53, { bizIdentity });

    if (res.data.status === 0) {
      yield put({
        type: DETAIL_GET_GRADE_SUCCESS,
        payload: { ...res.data.data },
      });
    }
  } catch (error) {
    // throw error;
  }
}

/**
 * 获取应用评论list
 */
function* fetchAddZan({ id, originalCommentId, username }) {
  try {
    yield put({
      type: DETAIL_ADD_ZAN_SUCCESS,
      payload: { inLoadding: true, id, originalCommentId, username },
    });
    const axios = yield createAxios('isNeedUser');
    const res = yield axios.post(DETAIL_ADD_ZAN_53, { id, originalCommentId, username });

    if (res.data.status === 0) {
      yield put({
        type: DETAIL_ADD_ZAN_SUCCESS,
        payload: { ...res.data.data, inLoadding: false, id, originalCommentId, username },
      });
      // message.info('点赞成功');
      message.success({
        content: '点赞成功',
        className: 'ant-message-notice-center',
        icon: <img className="ant-message-custom-img" src={success} alt="success" />,
      });
    } else {
      // message.info(res.data.message);
      message.error({
        content: res.data.message || '点赞失败，请稍后再试',
        icon: <img className="ant-message-custom-img" src={fail} alt="success" />,
      });
    }
  } catch (error) {
    yield put({
      type: DETAIL_ADD_ZAN_SUCCESS,
      payload: { inLoadding: false, id, originalCommentId, username },
    });
    // message.info('点赞失败，请稍后再试');
    message.error({
      content: '点赞失败，请稍后再试',
      icon: <img className="ant-message-custom-img" src={fail} alt="success" />,
    });
  }
}

/**
 * 获取应用评分信息
 */
function* fetchAddScoreForStore({ score }) {
  try {
    const axios = yield createAxios('isNeedUser');
    const res = yield axios.get(USER_SCORE_FORSTORE_70, {
      params: { score },
    });

    if (res.data.status === 0) {
      yield put({
        type: USER_SCORE_FORSTORE_SUCCESS,
        payload: { ...res.data.data },
      });
    }
  } catch (error) {
    // throw error;
  }
}

export function* watchFetchGetCommentList() {
  yield takeLatest(DETAIL_GET_COMMENT_LIST_REQUEST, fetchGetCommentList);
}
export function* watchFetchGetGrade() {
  yield takeLatest(DETAIL_GET_GRADE_REQUEST, fetchGetGrade);
}
export function* watchFetchAddComment() {
  yield takeLatest(DETAIL_ADD_COMMENT_REQUEST, fetchAddComment);
}
export function* watchFetchAddZan() {
  yield takeLatest(DETAIL_ADD_ZAN_REQUEST, fetchAddZan);
}
export function* watchFetchAddScoreForStore() {
  yield takeLatest(USER_SCORE_FORSTORE_REQUEST, fetchAddScoreForStore);
}
